export const validateEntryPoints = (list, entryPoints) => {
	if (!list || !Array.isArray(list)) return false;

	let result = true;
	list.forEach((item) => {
		if (!entryPoints.includes(item)) {
			result = false;
		}
	});
	return result;
};
